var render = function render(){var _vm=this,_c=_vm._self._c;return _c('square-button',{attrs:{"icon":_vm.lineSizeIcon,"tooltip-text":_vm.tooltipText,"flat":""},on:{"click":_vm.onButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }